import React from "react";
import PropTypes from "prop-types";

import PrintDocumentDiscount from "./printDocumentDiscount";
import {
  discountSectionExistsInCurrentWizardSelections,
  // discountSectionExistsInCurrentWizardSelections,
  getDiscountsForSection,
  isSaveOnlyDiscount,
  shouldCalculateDiscount
} from "../../priceWorksheet/discountFunctions";
import {getQuotePriceWithTaxes, getTotalPrice, sortByOrder} from "../../../misc/helpers";
import {DISCOUNT_SECTION_TYPES} from "../../priceWorksheet/discounstInterface";


const PrintDocumentDiscountsList = (props) => {
  const {styles, priceWorksheetState, fabricatorSettings, messages, wizardState, hasMultipleWorkSheets, quoteIndex} = props;
  const {discountSections, customAddedDiscounts} = priceWorksheetState;

  const {View, Text} = window.ReactPdfRenderer;

  const totalPrice = getTotalPrice();
  const grandTotal = getQuotePriceWithTaxes(totalPrice);

  return (
    <View style={styles.discounts}>
      {discountSections.map((discountSection, discountSectionIndex) => {
        if (discountSection.type === DISCOUNT_SECTION_TYPES.finance) {
          return null
        }
        if (hasMultipleWorkSheets && !discountSectionExistsInCurrentWizardSelections(
          discountSection,
          wizardState.allWizardsValues,
          quoteIndex)) {
          return null
        }
        const allDiscounts = getDiscountsForSection(discountSection, customAddedDiscounts);
        const displayDiscounts = sortByOrder(allDiscounts.filter(discount => {
          return shouldCalculateDiscount(discount, quoteIndex, hasMultipleWorkSheets)
            || isSaveOnlyDiscount(discount)
        }));
        if (!displayDiscounts.length) {
          return null
        }
        return (
          <View style={hasMultipleWorkSheets ? [styles.marginL20, styles.marginB10] : styles.discountSection}
                wrap={false}
                key={discountSectionIndex}>
            <Text style={styles.subPartTitle}>{discountSection.name}</Text>
            {displayDiscounts.map((discount, discountIndex) => {
              return <PrintDocumentDiscount discount={discount}
                                            key={discountIndex}
                                            grandTotal={grandTotal}
                                            priceWorksheetState={priceWorksheetState}
                                            discountSection={discountSection}
                                            fabricatorSettings={fabricatorSettings}
                                            messages={messages}
                                            hasMultipleWorkSheets={hasMultipleWorkSheets}
                                            quoteIndex={quoteIndex}
                                            styles={styles}/>
            })}
          </View>
        )
      })}
    </View>
  )
};

PrintDocumentDiscountsList.propTypes = {
  priceWorksheetState: PropTypes.object.isRequired,
  fabricatorSettings: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentDiscountsList
